import React, { useState } from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import styled from "styled-components";

import ImageGalleryContainer from "containers/ImageGalleryContainer.jsx";
import { HiOutlineZoomIn } from "react-icons/hi";
import { IconContext } from "react-icons";

import { trackAnalyticsEvent, buyplanContext } from "apis/analyticsHelpers.js";

const Zoom = ({
  className,
  productReleaseId,
  buyplanId,
  stockModalId,
  buyplanState,
  smType,
  isThreeSixty,
  tenantId,
  brandScopeTag,
  OrbUrl,
  // Separate from productReleaseId, which also gates the zoom-in icon's own
  // visibility below — SurroundView's 360 instance of this component
  // deliberately doesn't pass productReleaseId (so that icon stays hidden
  // here, see the three-sixty-icon branch instead), but still needs a
  // product release id for tracking, hence this second, display-neutral prop.
  recordId
}) => {
  const isThreeSixtyView = isThreeSixty && brandScopeTag && tenantId;

  let [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    trackAnalyticsEvent("product_card_action", {
      category: isThreeSixtyView ? "360 View" : "Zoom",
      record_type: "product_release",
      record_id: productReleaseId || recordId,
      ...buyplanContext(buyplanId, stockModalId, buyplanState, smType),
      path: window.location.pathname
    });
    setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);
  return (
    <>
      <div
        className={`zoom ${className}`}
        onClick={openModal}
      >
        {isThreeSixtyView && (
          <div className='three-sixty-icon'>
            <img src="/360-icon.png" alt="360 icon" width="26" />
          </div>
        )}

        {productReleaseId && (
          <div className="zoom-item-quantity">
            <IconContext.Provider value={{ className: "zoom-icon" }}>
              <HiOutlineZoomIn size={26} />
            </IconContext.Provider>
          </div>
        )}
      </div>

      {isModalOpen && (
        <Modal
          className={`${className} modal-container mw-100 m-0`}
          isOpen={isModalOpen}
          toggle={closeModal}
          backdrop={true}
          size="preview"
        >
          <ModalBody className="w-100 text-center p-0">
            <Button close onClick={closeModal} />
            {isThreeSixtyView ? (
              <iframe
                id="surroundingFrame"
                title="Orb 360"
                width="96%"
                height="100%"
                frameBorder="0"
                allowFullScreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                src={OrbUrl}
              ></iframe>
            ) : (
              <ImageGalleryContainer
                productReleaseId={productReleaseId}
                buyplanId={buyplanId}
                OrbUrl={OrbUrl}
              />
            )}
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

const StyledZoom = styled(Zoom)`
  &.modal-preview {
    @media (max-width: 575.98px) {
      padding-top: 60px;
      height: calc(100vh - 60px);
    }

    .modal-content {
      border-radius: 0;

      @media (max-width: 575.98px) {
        height: calc(100vh - 60px);
      }
    }
  }

  button.close {
    position: absolute;
    top: 13px;
    right: 4px;
    z-index: 10;
    color: #000;
    opacity: 1;

    span {
      display: block;
      font-size: 70px;
      line-height: 40px;
    }
  }

  .modal-body {
    height: 100vh;
    @media (max-width: 575.98px) {
      display: flex;
      align-items: center;
    }

    > img {
      height: 100vh;
      width: auto;
      margin-top: 0;

      @media (max-width: 575.98px) {
        width: 100%;
        height: auto;
      }
    }
  }
  margin-bottom: 1ex;
  cursor: pointer;

  svg {
    width: 1.6em;
    height: auto;
    stroke: #bdbdbd;
  }
  .zoom-icon {
    width: 22px;
    margin-top: 2px;
  }

  .three-sixty-icon {
    margin-top: 1ex;
    margin-bottom: 1ex;
  }

  .zoom-item-quantity, .three-sixty-icon {
    background-color: #ffffff;
    position: static;
    border: solid 1.5px #e5e5e5;
    border-radius: 3px;
    color: #c1c1c1;
    font-family: "Roboto";
    font-size: 10px;
    font-weight: 600;
    text-align: center;
    width: 28px;
    height: 28px;
  }
`;

export default React.memo(StyledZoom);
